'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { faUserDoctor as f } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { faEllipsis as N } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { FontAwesomeIcon as n } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import c from "html-react-parser";
import { useCallback as g, Fragment as v } from "react";
import { useInView as b } from "../../external/react-intersection-observer/index.js";
import { formatDate as h, formatTime as p } from "../../helpers/dateUtils.js";
import { getFullName as U } from "../../helpers/doctorUtils.js";
import s from "./chat.module.scss.js";
const k = ({
  messages: t,
  identity: i,
  doctor: l,
  hasMoreMessages: d = !1,
  onEndReached: x
}) => {
  const m = U(l), { ref: j } = b({
    threshold: 1,
    onChange: (a) => {
      d && a && x();
    }
  }), u = g(
    (a, r) => {
      const o = h(a);
      return r === t.length - 1 || o !== h(t[r + 1].dateUpdated) ? /* @__PURE__ */ e.jsx("small", { className: s["messages--date"], children: o }) : null;
    },
    [t]
  );
  return /* @__PURE__ */ e.jsxs("div", { className: s.messages, children: [
    t.map((a, r) => /* @__PURE__ */ e.jsxs(v, { children: [
      /* @__PURE__ */ e.jsx(
        "div",
        {
          "data-testid": "message",
          className: s.message,
          "data-is-outbound": a.author === i,
          children: a.author !== i ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("div", { className: s["message--avatar"], children: l.image ? /* @__PURE__ */ e.jsx("picture", { children: /* @__PURE__ */ e.jsx(
              "img",
              {
                src: l.image,
                alt: m
              }
            ) }) : /* @__PURE__ */ e.jsx(
              n,
              {
                icon: f,
                width: 36,
                height: 32
              }
            ) }),
            /* @__PURE__ */ e.jsxs("div", { className: s["message--details"], children: [
              /* @__PURE__ */ e.jsx(
                "small",
                {
                  className: s["message--author"],
                  children: m
                }
              ),
              /* @__PURE__ */ e.jsx("div", { className: s["message--text"], children: a.body ? c(a.body) : null }),
              /* @__PURE__ */ e.jsx("p", { className: s["message--time"], children: p(a.dateUpdated) })
            ] })
          ] }) : /* @__PURE__ */ e.jsxs("div", { className: s["message--details"], children: [
            /* @__PURE__ */ e.jsx("div", { className: s["message--text"], children: a.body ? c(a.body) : null }),
            /* @__PURE__ */ e.jsx("p", { className: s["message--time"], children: p(a.dateUpdated) })
          ] })
        }
      ),
      a.dateUpdated ? u(a.dateUpdated, r) : null
    ] }, a.id)),
    d ? /* @__PURE__ */ e.jsx("div", { ref: j, className: s["loading-container"], children: /* @__PURE__ */ e.jsx(n, { icon: N }) }) : null
  ] });
};
export {
  k as default
};
